import React, { PureComponent } from 'react';
import strings from 'helper/localization/localization';
import { countries } from 'helper/countries';

export default class SignupCountry extends PureComponent {
  constructor(props) {
    super(props);

    // State
    this.state = {
      country: 'DE',
      countries: countries,
    };

    // Properties
    this.api = this.props.api;
    this.updateDetails = this.props.updateDetails;

    // Bindings
    this.toNextStep = this.toNextStep.bind(this);
    this.countryChanged = this.countryChanged.bind(this);
  }

  toNextStep(e) {
    e.preventDefault();

    this.updateDetails('country', this.state.country);
  }

  countryChanged(e) {
    this.setState({ country: e.target.value });
  }

  render() {
    return (
      <form>
        <div className="form-group">
          <label htmlFor="signup--country">{strings.whatIsYourCountry}</label>
          <select
            className="form-control"
            id="signup--country"
            onChange={this.countryChanged}
            value={this.state.country}
          >
            {this.state.countries.map(c => (
              <option
                value={c.isoCode}
                key={c.isoCode}
              >{c.name}
              </option>))}
          </select>
        </div>
        <button
          type="submit"
          className="btn btn-outline-primary btn-lg btn-block"
          onClick={this.toNextStep}
          id="signup-country--save"
        >
          {strings.next}
        </button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/signup/components/SignupCountry.jsx